export const SOFTLINE_PERMISSION_ABC_ANALYSIS = 'SOFTAPPS.ABC_ANALYSIS';
export const SOFTLINE_CONST_LAGER_ABC_ANALYSIS_CONFIG_KEY = 'abc-analysis/config';
export const SOFTLINE_CONST_LAGER_ABC_ANALYSIS_MODULE_HEADER = 'esl-search';
